import { getScreenId } from "./getScreenId";

export const buildKioskShortlink = () => {
  const screenId = getScreenId();

  return process.env.REACT_APP_SHORTLINK_URL
    ? `${process.env.REACT_APP_SHORTLINK_URL}/k/${screenId}`
    : `https://shortlink-api.dev1.livingmap.com/v1/k/${screenId}/`;
};
